import React from 'react'
import "./About.css"
import AboutSection from './AboutSection'
import circle from "./About_Images/circle.png"
import mission from "./About_Images/mission.svg"
import technology from "./About_Images/technology.png"
import story from "./About_Images/story.svg"

const About = () => {
  return (
    <div className="about_main">
      <AboutSection h3="Who we" h1="Are?" p="Smash Code is a team of skilled Developers, Graphic Designers, and Copy Writers committed to fulfilling the needs of our clients to their satisfaction level. We work hard to keep up with innovative solutions. We focus on unique designs and robust development from start to finish so that you remain focused on your core business." imgsrc={circle}/>

      <AboutSection h3="Our" h1="Missions" p="Smash Code aims to provide depth and breadth services to our valuable customers with free support all the time. Our team is committed to going the extra mile to take your business to the next level." imgsrc={mission}/>

      <AboutSection h3="Technologies we" h1="Use" p="To create robust and responsive websites, web apps, and full-stack web apps, we use next-generation programming languages such as HTML, CSS, JS, ReactJs and Firebase, and for graphic designing we use Adobe Illustrator & Photoshop." imgsrc={technology}/>

      <AboutSection h3="Our" h1="Story" p="Smash Code is a Web Design & Development Company based in Faisalabad, Pakistan founded in 2019 Our team consists of skilled Web Designers & Developers, Graphic Designers, and Copy Writes. We offer quality services of unique web designs & robust developments, professional business logo & poster design, and engaging content for web pages. We have worked with great clients worldwide, ranging from startups to large firms." imgsrc={story}/>
    </div>
  )
}

export default About
